import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, ENUM_MOD_NAME, stateEnum } from "../constants/enum.js"
import customAPI from "../api/customAPI.js"

const { pktTransfer } = stateEnum;

let initialState = {
  detailParams: {},
  isNewEntry: false,
  rptPktData: [],
  pktModSetData: [],
  stockPktData:{fromLocation:"",data: []}
};



export const setPktDetail = createAsyncThunk(
  "memo/fetchMemoDetail",
  async ({ token, comp_code, trans_id, bill_type, trade_of, db_user }) => {
    try {
      const { data } = await customAPI.post(
        apiRoute.memoEntry.fetchMemoData,
        {
          compcode: comp_code,
          billtype: bill_type,
          tradeof: trade_of,
          transid: trans_id,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      console.log(data.data)
      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)

export const setModSettingData = createAsyncThunk(
  "memo/fetchModSettingDetail",
  async ({ token, mod_name, db_user }) => {
    try {

      const { data } = await customAPI.post(
        apiRoute.modSetting.getMultiModSetting,
        {
          page_mod: mod_name,
          master_mod: ENUM_MOD_NAME.GeneralSettings,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)
const packetTransferSlice = createSlice({
  name: pktTransfer,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(setPktDetail.fulfilled, (state, action) => {
        state.rptPktData = action.payload
      })
      .addCase(setPktDetail.rejected, (state, action) => {
        state.rptPktData = []
      });
    builder
      .addCase(setModSettingData.fulfilled, (state, action) => {
        state.pktModSetData = action.payload
      })
      .addCase(setModSettingData.rejected, (state, action) => {
        state.pktModSetData = []
      });
  },
  reducers: {
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload;
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetail: (state) => {
      state.detailParams = {};
      state.isNewEntry = true;
      state.stockPktData={fromLocation:"",data: []}
    },
    resetReportData: (state) => {
      state.rptPktData = []
      state.pktModSetData = []
    },
    setStockPktData: (state, action) => {
      state.stockPktData = action.payload
    },
  },

});


export const { setNewEntryMode, setDetailParams, resetReportData, resetDetail ,setStockPktData} = packetTransferSlice.actions;
export default packetTransferSlice.reducer;
